/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentList } from './appointmentList';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedAppointmentListList { 
    next?: string | null;
    previous?: string | null;
    results: Array<AppointmentList>;
}
export const PaginatedAppointmentListList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedAppointmentListList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedAppointmentListList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


